import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { FaAngleRight } from "react-icons/fa";
import Slider from "react-slick";

function ProductSlider() {


   const settings1 = {
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 715,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  };
  const products = [
    {
      id: "e0c644047c75dcf12413f34032db31cb8fc3896b49f6f76bcc164d58f82edd73f1612d0b635c25b0e8a154c919ae5d1e1b9cfe8cdc51864f0afc2b4ce0df64e6",
      title: "Swish women’s basketball jersey",
      image: "/asset/img/Ecom/30.webp",
    },
    {
      id: "358555cbd45a189f283ce021bc712f34d8d78c500c9b9f8aff4fd21383a0a24133c13558dd79ef7a2a4c8236033222f523b635d4b619eb3489fc35c84deb7b03",
      title: "Men’s basketball shooter shirt",
      image: "/asset/img/Ecom/33.webp",
    },
    {
      id: "123fc4b0b55d1e43da5b95491985f2bebd948dda3d2ba2eeb2667e9b35422a8853c28b7ee7503833a33f1b39b05068f83088ac2ad82fec116924550ab00c8403",
      title: "Viborg men's handball jersey l/s",
      image: "/asset/img/Ecom/13.webp",
    },
    {
      id: "3c83f338429dcd2f677ce95236925cfee5aba132751b1b6b6aa7c8db7cb8450e2efb066c103f4cdc7bec71b0b79ee9ee44bd6418b41c1451aa95976c33b57fd8",
      title: "Skjern women's handball jersey",
      image: "/asset/img/Ecom/29.webp",
    },
    {
      id: "f5de0a11181233d8fc946a97d8b8ea10b186293869aa4921a87f228ca57bb0809b26c8db5993981a8fb089e191f15304c733698b54e675f1e8fb546f0eb8326d",
      title: "Viborg men's handball jersey",
      image: "/asset/img/Ecom/19.webp",
    },
    {
      id: "6a65b0a01149ebaa07c3612e911022378a445b834934b29ac5f133678d1206f638a38c568ac14d3f47369d914f093e1e13b42c964d8206ef5cf2a5a8f4660c05",
      title: "Viborg men's handball jersey",
      image: "/asset/img/Ecom/28.webp",
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <div
        className="col-12"
        data-cms-element-id="01909d40d9827a2aa5d33ff1fdefab27"
      >
        <style jsx>{`
        /* Base Styles */
        .storefront-container {
          position: relative;
          overflow: hidden;
        }

        .storefront-col {
          width: 100%;
          position: relative;
          z-index: 2;
        }

        .storefront-slider-title {
          padding: 40px 20px;
          position: relative;
        }

        .storefront-title-section {

          backdrop-filter: blur(20px);

         padding-bottom:50px !important;
          position: relative;
          overflow: hidden;
          transform: translateY(30px);
          opacity: 0;
          animation: floatUp 1s ease-out forwards;
          padding:15px;
        }

        .storefront-title-section:nth-child(2) {
          animation-delay: 0.4s;
        }

        .storefront-title-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4);
          background-size: 300% 100%;
          animation: gradientFlow 3s ease-in-out infinite;
        }

        .storefront-title-section::after {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          animation: rotateBg 8s linear infinite;
          pointer-events: none;
        }

        .storefront-main-title {
          font-size: 2rem;
          font-weight: 500;
          color: #000000;
          position: relative;
          z-index: 2;
          animation: titleGlow 2s ease-in-out infinite alternate;
          text-align: center;
          width: 100%;
          max-width: 100%;
        }

        .storefront-main-description {
        color :black;
          font-size: 1.1rem;

          line-height: 1.7;

          position: relative;
          z-index: 2;
          text-align: center;
          animation: fadeInScale 0.8s ease-out 0.6s forwards;
          opacity: 0;
          transform: scale(0.95);
        }

        .storefront-client-title {
          font-size: 1.4rem;
          font-weight: 700;
          color: #4ecdc4;
          position: relative;
          z-index: 2;
          text-align: center;
          animation: bounceIn 0.6s ease-out 1s forwards;
          opacity: 0;
          transform: translateY(-20px);
        }

        .storefront-client-title::before {
          content: '⭐';

          animation: sparkle 1.5s ease-in-out infinite;
        }

        .storefront-client-title::after {
          content: '⭐';

          animation: sparkle 1.5s ease-in-out infinite 0.5s;
        }

        .storefront-content-text {
          font-size: 1rem;
          color:black;
          line-height: 1.6;

          position: relative;
          z-index: 2;
          text-align: center;
          animation: slideInLeft 0.8s ease-out 1.2s forwards;
          opacity: 0;
          transform: translateX(-30px);
        }

        .storefront-content-text:last-child {
          margin-bottom: 0;
          animation-delay: 1.4s;
        }

        .storefront-highlight-text {
          background: linear-gradient(90deg, #ff6b6b, #4ecdc4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 600;
          position: relative;
        }

        .storefront-highlight-text::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, #ff6b6b, #4ecdc4);
          animation: expandLine 0.8s ease-out 2s forwards;
          width: 0;
        }

        

      

        .storefront-title-section:hover .storefront-main-title {
          transform: scale(1.02);
          transition: transform 0.3s ease;
        }

        /* Animations */
        @keyframes floatUp {
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes gradientFlow {
          0%, 100% {
            background-position: 0% 0%;
          }
          50% {
            background-position: 100% 0%;
          }
        }

        @keyframes rotateBg {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes titleGlow {
          0% {
            filter: brightness(1);
          }
          100% {
            filter: brightness(1.1);
          }
        }

        @keyframes fadeInScale {
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes bounceIn {
          0% {
            opacity: 0;
            transform: translateY(-20px) scale(0.8);
          }
          60% {
            opacity: 1;
            transform: translateY(5px) scale(1.05);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @keyframes slideInLeft {
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes sparkle {
          0%, 100% {
            transform: scale(1) rotate(0deg);
          }
          50% {
            transform: scale(1.2) rotate(180deg);
          }
        }

        @keyframes expandLine {
          to {
            width: 100%;
          }
        }

        /* Mobile Media Queries */
        @media screen and (max-width: 768px) {

          .storefront-slider-title-mobile {
            padding: 30px 15px;
          }

          .storefront-title-section-mobile {
            padding: 30px 25px;
          }

          .storefront-main-title-mobile {
            font-size: 2rem;

            line-height: 1.2;
          }

          .storefront-main-description-mobile {
            font-size: 1rem;
   
            padding: 0 10px;
          }

          .storefront-client-title-mobile {
            font-size: 1.3rem;

          }

          .storefront-content-text-mobile {
            font-size: 0.95rem;

            padding: 0 5px;
          }

          .storefront-title-section:hover {
            transform: translateY(-3px);
          }
        }

        @media (max-width: 767.98px) {
    .configurator-product-slider1 {
        margin-top: 0px !important;
    }
}

        @media screen and (max-width: 480px) {
configurator-product-slider {
    margin-top: 8px !important;
        }
          .storefront-slider-title-small {
            padding: 25px 12px;
          }

          .storefront-title-section-small {
            padding: 25px 20px;

          }

          .storefront-main-title-small {
            font-size: 1.8rem;

            line-height: 1.1;
          }

          .storefront-main-description-small {
            font-size: 0.95rem;
            line-height: 1.6;
          }

          .storefront-client-title-small {
            font-size: 1.2rem;
          }

          .storefront-client-title-small::before,
          .storefront-client-title-small::after {
            font-size: 0.9rem;
          }

          .storefront-content-text-small {
            font-size: 0.9rem;

          }
            .storefront-content-text-xs {
            font-size: 12px;
            color:black;
     
          }
        }

        @media screen and (max-width: 360px) {
          .storefront-slider-title-xs {
            padding: 20px 10px;
          }

          .storefront-title-section-xs {
            padding: 20px 16px;

          }

          .storefront-main-title-xs {
            font-size: 1.6rem;

          }

          .storefront-main-description-xs {
          color:black;
            font-size: 0.9rem;

          }

          .storefront-client-title-xs {
            font-size: 1.1rem;

          }

          .storefront-content-text-xs {
            font-size: 12px;
            color:black;
     
          }
        }

        /* Additional Mobile Enhancements */
        @media screen and (max-width: 768px) {
          .storefront-title-section::before {
            height: 2px;
          }
        }
      `}</style>


     
      </div>
     
      <div className="block-container-2 configurator-product-slider">

        <p style={{paddingTop:"24px",paddingBottom:"10px",fontSize:window.innerWidth <= 567?"20px":"48px",
          fontWeight:window.innerWidth<567?800:600,fontFamily:"Poppins",textAlign:window.innerWidth<567?"center":"left"}}>Blogs
         <br/>
         {window.innerWidth<567 &&  <span style={{fontFamily:"Poppins",color:"gray",fontSize:"12px",textAlign:"center",fontWeight:"normal"}}>
                  Shield X Sports Blogs and Articles</span>}
          </p>

       

        <div style={{width:"100%"}}>
          <Slider {...settings1}>
          {products.map((product) => (
            <div style={{height:"250px",}}>
                <img
                    src={product.image}
                    className="img-fluid f_lazy"
                    alt={product.title}
                    style={{ width: "100%", height: "200px",padding:"4px" }}
                    loading="lazy"
                  />
                    <p style={{width:"100%",color:"#000000ff",paddingTop:"10px",paddingLeft:"5px",fontSize:window.innerWidth<567?"15px":"16px",fontWeight:400,fontFamily:"Poppins"}}>{product.title}</p>
              {/* <p style={{width:"100%",color:"#4e4d4dff",paddingTop:"0px",paddingLeft:"5px",fontSize:window.innerWidth<567?"15px":"12px",fontWeight:300,fontFamily:"Poppins"}}>{product.title}</p> */}
            </div>
          ))}

        </Slider></div>
      </div>
    </div>
  );
}

export default React.memo(ProductSlider);
